module.exports = __webpack_public_path__ + "static/media/case-study_course-outline.b20799b3.png";